/* VCTparts retourformulier, lader (versie 7).
   Gemaakt door het VCTparts-paneel (Instellingen, Retouren, Formulier insluiten). Dit bestand laadt de actuele code van
   het formulier van het paneel zelf; na een update van het paneel hoef je in het thema niets meer te kopiëren. */
(function () {
  "use strict";
  if (window.__vctRetourLader) return;
  window.__vctRetourLader = true;
  var el = document.querySelector("[data-vct-retour]");
  if (!el) return;
  var paneel = (el.getAttribute("data-paneel") || "").replace(/\/+$/, "");
  if (!/^https:\/\/[A-Za-z0-9.-]+(:[0-9]+)?$/.test(paneel) && !/^http:\/\/(localhost|127\.0\.0\.1)(:[0-9]+)?$/.test(paneel)) {
    el.innerHTML = '<div class="vct-fout">Retourformulier: het adres van het paneel klopt niet.</div>';
    return;
  }
  var css = document.createElement("link");
  css.rel = "stylesheet";
  css.href = paneel + "/api/retourformulier/code/vct-retourformulier.css";
  document.head.appendChild(css);
  var js = document.createElement("script");
  js.src = paneel + "/api/retourformulier/code/vct-retourformulier.js";
  js.defer = true;
  js.onerror = function () { el.innerHTML = '<div class="vct-fout">Het retourformulier kon niet laden. Probeer het later opnieuw of neem contact met ons op.</div>'; };
  document.head.appendChild(js);
})();
